/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Cc_CreatorInputs */



/**
* | output |
* | --- |
* | "About CC Creator" |
*
* @param {About_Cc_CreatorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const about_cc_creator = /** @type {((inputs?: About_Cc_CreatorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Cc_CreatorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("À propos de CC Creator")
	if (locale === "de") return /** @type {LocalizedString} */ ("Über CC Creator")
	if (locale === "it") return /** @type {LocalizedString} */ ("Informazioni su CC Creator")
	if (locale === "ru") return /** @type {LocalizedString} */ ("О CC Creator")
	if (locale === "es") return /** @type {LocalizedString} */ ("Acerca de CC Creator")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("关于 CC Creator")
	if (locale === "ja") return /** @type {LocalizedString} */ ("CCクリエイターについて")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सीसी क्रिएटर के बारे में")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sobre o CC Creator")
	return /** @type {LocalizedString} */ ("About CC Creator")
});